import { useState, useEffect } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material'
import { formatTime } from '../../../../helper/converters';
import TimeTool from '../../../components/time-tool'

import './index.scss'

const ProjectCard = (props: any) => {

    const { urlAvatar, numProject, timeGeneral, category, comment, title, timeParticipant } = props;
    const [categoryTxt, setCategoryTxt] = useState('');
    const [commentTxt, setCommentTxt] = useState('');

    useEffect(() => {
        setCategoryTxt(category);
        setCommentTxt(comment);
    }, [comment, category])

    const defaultImage =
        "https://cinemahive.s3.amazonaws.com/images/logos/Project+%E2%80%93+1.png";

    return (
        <div className="card">
            <div className="card-image">
                <img
                    className="square"
                    src={urlAvatar ? urlAvatar : defaultImage}
                    alt="user"
                />
            </div>
            <div className="card-information">
                <h4 className="card-information-title">{title}</h4>
                {numProject && (
                    <h4 className="card-information-sub-title">
                        {`Project Number: ${numProject}`}
                    </h4>
                )}
                <h3 className="card-information-sub-title-bold">Your Call Time</h3>
                <TimeTool
                    disabled={true}
                    size="big"
                    time={timeParticipant ? formatTime(timeParticipant) : ""}
                />
                <br />
                <h6>General Crew Call Time: </h6>
                <h6>{timeGeneral ? formatTime(timeGeneral) : ""}</h6>
            </div>
            <hr className="divide-line" />
            <Autocomplete
                sx={{ fontSize: "10px" }}
                fullWidth
                id="category"
                disableClearable
                disabled
                options={["SHOOT DAY", "SCOUT", "REHEARSAL", "MEETING", "FITTING"]}
                value={categoryTxt}
                renderOption={(props, option) => (
                    <Box
                        component="li"
                        {...props}
                        key={option}
                    >
                        {option}
                    </Box>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        name="category"
                        label="Category"
                        value={categoryTxt}
                    />
                )}
            />
            <div className="card-information-textarea">
                <textarea
                    disabled
                    rows={5}
                    maxLength={200}
                    value={commentTxt}
                ></textarea>
            </div>
        </div>
    )
}

export default ProjectCard
